import React, { useContext, useEffect } from "react";
import { useQuery } from "@apollo/react-hooks";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";

import NotFound from "core/NotFound";
import PhotoDetail from "photos/PhotoDetail";
import { PhotosContext } from "photos/context";

import { PhotoDetailDocument } from "js/graphql";

const PhotoDetailPage = () => {
    // We need to manually take control of the browsers scrollRestoration
    window.history.scrollRestoration = "manual";

    const {
        match: {
            params: { photoSlugWithId }
        }
    } = useContext(PhotosContext);

    const photoId = photoSlugWithId.split("-").pop();

    const { loading, data } = useQuery(PhotoDetailDocument, {
        fetchPolicy: "cache-and-network",
        skip: !photoId,
        variables: {
            photoId
        }
    });

    if (window.pageYOffset !== 0) {
        window.scrollTo(0, 0);
    }

    useEffect(() => {
        return () => {
            // We need to reset the browsers scrollRestoration to
            // auto so that we don't potentially break other page scroll
            window.history.scrollRestoration = "auto";
        };
    }, []);

    return (
        <div>
            <Helmet>
                <title>Photo</title>
            </Helmet>
            {(!data || !data.photoDetail) && !loading ? (
                <NotFound />
            ) : (
                <PhotoDetail
                    photoId={photoId}
                    photo={loading ? null : data.photoDetail}
                />
            )}
        </div>
    );
};

PhotoDetailPage.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            photoSlugWithId: PropTypes.string.isRequired
        }).isRequired
    })
};

export default PhotoDetailPage;
